import React from 'react';
import { Page, Layout, Card, Box, InlineStack, BlockStack } from '@shopify/polaris';
import styles from './Skeleton.module.scss';

/**
 * 聊天页面骨架屏组件
 */
const ChatSkeleton: React.FC = () => {
  return (
    <Page title="Chat">
      <Layout>
        <Layout.Section>
          <Card>
            <Box padding="400">
              <InlineStack gap="400">
                <span className={styles.sidebarSkeleton} />
                <Box>
                  <BlockStack gap="400">
                    <span className={styles.chatHeaderSkeleton} />
                    <span className={styles.chatMessagesSkeleton} />
                    <span className={styles.chatInputSkeleton} />
                  </BlockStack>
                </Box>
              </InlineStack>
            </Box>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default ChatSkeleton; 